<template> <!--TO DO! change hard coded lookup to api form lookup-->
    <div style="border-radius: 50px">
        <!--
        <div class="row">
            <div class="col">
                
                    <q-btn-toggle
                    spread
                    v-model="Form.AmountUnits"
                    toggle-color="primary"
                    :options="[
                        {label: 'Amount', value: 'Amount'},
                        {label: 'Units', value: 'Units'}
                    ]"
                    @input="AmountUnitSelection(Form.AmountUnits)"
                />                
            </div>
        </div>
        v-if="UnitsLeft > StoreStateT.Transaction.minRedemption"
        -->
        <div class="row q-pa-sm">
            <!-- <div class="col">
                {{$t("Redeem.fundselected")}}
                <div class="text-h6">
                    {{FundName}}
                </div>
            </div> -->
            <!-- <div class="row q-pa-md"> -->
            <!-- <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm text-weight-bold">{{ $t("Redeem.fundselected").toUpperCase() }}</div> -->
            <!-- <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm text-weight-medium">{{ FundName.toUpperCase() }}</div> -->
            <div class="col">
            <div class="text-bold" style="font-size: 14px;">{{ FundName }}</div>
            </div>

        </div>
        <br> 
        <div class="row q-pb-md" >            
            <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-md">
                <b>{{$t("Redeem.MinRedemUnit")}}</b>
                <q-input 
                class="text-right"
                outlined
                standout
                :value="StoreStateT.Transaction.minRedemption | thousandSeparator"  
                stack-label    
                readonly/>                   
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-md">
                <b>{{$t("Redeem.MinAcctBalance")}}</b>
                <q-input
                outlined
                standout
                class="text-right"
                :value="StoreStateT.Transaction.minAccountBalance | thousandSeparator"  
                stack-label 
                readonly/> 
            </div>
        </div>
        <!-- <br> -->
        <div class="row">            
            <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-md">
                <b>{{$t("Redeem.balanceunit")}}</b>
                <q-input
                outlined
                standout
                :value="BalanceUnit | thousandSeparator"  
                stack-label   
                readonly/>                   
            </div>
            <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-md">
                <b>{{$t("Redeem.currentnav")}}</b>
                <q-input
                outlined 
                standout
                :value="NAV"  
                stack-label   
                :hint="'as of ' + NAVDate"
                readonly/>                   
            </div>
        </div>
        <!-- <br> -->
        <div class="row q-pb-md">
            <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm q-pb-sm">
                <b>{{$t("Redeem.currentamount")}}</b>
                <q-input
                outlined
                standout
                :value="BalanceAmount | thousandSeparator" 
                stack-label 
                prefix="MYR"
                readonly/>
            </div>
            <div bottom-slots class="col-xs-12 col-sm-6 col-md-6 q-px-sm" v-if="Form.AmountUnits!=='Amount'">
                <!-- <q-input 
                v-model.lazy="price"
                v-money="money"
                outlined 
                v-model="Form.Units" 
                label="Units" 
                :readonly="Form.RedeemAllUnits"
                lazy-rules
                :rules="[ val => RemoveFormat(val) <= Number(BalanceUnit) && val !== '' && val !== 0 || 'Must not more than ' + BalanceUnit.toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 2}) + ' units']" 
                />{{Form.Units}} -->
                <b>{{$t("Redeem.units")}}</b>
                <q-input 
                    outlined
                    standout
                    ref="RefUnit"
                    v-model="Form.Units" 
                    v-money="money"
                    :rules="[ val => RemoveFormat(val) <= Number(BalanceUnit) && RemoveFormat(val) !== '' && RemoveFormat(val)!== 0 || '' + $t('Redeem.notMore') +' '  + BalanceUnit.toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 2}) + ' units',
                    val => RemoveFormat(val) != 0.00  || '' + $t('Redeem.invalidUnit') +' ' , val => 0.00 < RemoveFormat(val) || '' + $t('Redeem.invalidUnit') +' ' ]" />
            </div>
            <div bottom-slots class="col-xs-12 col-sm-6 col-md-6 q-px-sm" v-else-if="Form.AmountUnits==='Amount' ">
                <q-input 
                prefix="MYR"
                outlined
                standout
                v-model.lazy="price"
                v-money="money"
                v-on:keyup="RemoveFormat(Form.Amount)"
                v-model="Form.Amount" 
                 :label='$t("Redeem.amount")'                
                           
                />
                <!-- <br> -->
            </div>
            
        </div>
        <div class="row q-pb-md">
            <!-- <div class="col"> -->
                <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm">
                <b>{{$t("Redeem.unitbalanceafterredeem")}}</b>
                    <q-input
                    outlined
                    standout
                    :value="UnitsLeft|thousandSeparator"   
                    stack-label 
                    readonly
                    :rules="[ val => RemoveFormat(val) <= Number(UnitsLeft) && RemoveFormat(val) !== '' && RemoveFormat(val)>= 0 || '' + $t('Redeem.notMore') +' '   + BalanceUnit.toLocaleString(undefined, {minimumFractionDigits: 0,maximumFractionDigits: 2}) + ' units']" 
                    />  
                    <!--
                         <q-input
                    standout
                    v-model="StoreStateT.UnitsLeft"
                    label="Units Left After Redeem" 
                    stack-label 
                    readonly/> 
                         <q-field
                        standout
                        readonly
                        v-model="UnitsLeft"
                        label="Units Left After Redeem"
                        class=""
                    >
                        <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                            <money :id="id" class="q-field__native text-left" :value="value" @input="emitValue" v-bind="money"  v-show="floatingLabel"/>
                        </template>
                    </q-field> -->
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 q-px-sm">
                <b>{{$t("Redeem.expectedamount")}}</b>
                     <q-input
                    outlined
                    standout
                    v-money="money"
                    :value="ExpectedAmount|thousandSeparator"  
                    stack-label 
                    prefix="MYR"
                    readonly/> 
                   <!--  <q-field
                        standout
                        readonly
                        v-model="ExpectedAmount"
                        label="Expected Amount"
                        class=""
                    >
                        <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                            <money :id="id" class="q-field__native text-left" :value="value" @input="emitValue" v-bind="money"  v-show="floatingLabel" prefix="MYR "/>
                        </template>
                    </q-field> -->
                </div>
        </div>
       <!--  <div class="row" v-if="Form.AmountUnits==='Units'">
            <div class="col">
                <q-toggle
                    v-model="Form.RedeemAllUnits"
                    label="Redeem All Units"
                    left-label
                    @input="PopulateAllUnits()"
                />
            </div>
        </div> -->
        <div class="row">
            <div class="col">
                <q-select 
                    v-if="Plan!=='EPF'"
                    filled 
                    v-model="Form.PaymentInstruction" 
                    :options="PaymentInstructionOptions" 
                    label="Payment Instruction" 
                />
                <!--
                <q-input
                    v-if="Plan==='EPF'"
                outlined
                    label="EPF No"
                    v-model="StoreStateCD.CustomerDetails.EPFNo" 
                    readonly
                />
                -->
            </div>
        </div>
    </div>
</template>

<script>
import store from '../store';  
import {VMoney, Money} from 'v-money'
import { mapState, mapActions } from "vuex";
export default {
    name: 'FundTransactionRedemption',
    components: {},
    props: ['BalanceUnit','BalanceAmount','Plan', 'FundName', 'NAV', 'NAVDate'],
    data () {
        return {
            StoreStateT : store.state.Transactions,
            StoreStateProduct : store.state.Product,
            StoreStateCD : store.state.CD,
            StoreStateBAD : store.state.BAD,
            StoreStateLogin: store.state.Login,
            money: {
                decimal: '.',
                thousands: ',',
                precision: 2,
                masked: false /* doesn't work with directive */
            },
            Form : {
                AmountUnits : 'UNITS',
                Amount : 0,
                Units : 0,
                RedeemAllUnits : false,
                Instruction : '',
                PaymentInstruction : '',
                Plan : 'EPF',
                PRSWithdrawalReason : '',
                CutOffTime : '',
               // UnitsLeft : 0,
                ExpectedAmount : 0
            },
            tempAmount : null,
            Amount : false,
            AddBankAccount : false,
            PaymentInstructionOptions : []
        }
    },
    directives: {money: VMoney},
    computed : {
        
        UnitsLeft : function(){
            var tempVall =""
            var Units = 0
            var FormatUnits =""
            var balanceUnitCalc=0;
            var FormatUnitsA=this.Form.Units.toString();
         
           // console.log(" --> "+FormatUnitsA)
            for(var j=0; j<this.StoreStateCD.Holdings.length; j++){
               
               if(this.FundName == this.StoreStateCD.Holdings[j].ProductName){

                balanceUnitCalc = this.StoreStateCD.Holdings[j].BalanceUnit + balanceUnitCalc
               }
                //alert(this.StoreStateCD.Holdings[j].BalanceUnit)
            }
           // console.log(balanceUnitCalc)

            if(FormatUnitsA.includes(',')){
                        FormatUnits=FormatUnitsA.replace(",","");
                        FormatUnits=FormatUnits.replace(",","");
                        FormatUnits= FormatUnits.trim() 
                        parseFloat(FormatUnits).toFixed(2)
                        //console.log(" FormatUnits ->"+ parseFloat(FormatUnits))
                        Units = balanceUnitCalc-parseFloat(FormatUnits).toFixed(2)
                        //console.log('total123--> ' +FormatUnits)
                }
                else{
                   parseFloat(FormatUnitsA).toFixed(2)
                   Units = balanceUnitCalc-FormatUnitsA 
                   //console.log('total--> ' +FormatUnitsA)
                } 
            return parseFloat(Units).toFixed(2);


        },
        
        ExpectedAmount : function(){
        var FormatUnits =""

        var FormatUnitsA=this.Form.Units.toString();
            if(FormatUnitsA.includes(',')){
                        FormatUnits=FormatUnitsA.replace(",","");
                        FormatUnits=FormatUnits.replace(",","");
                        FormatUnits= FormatUnits.trim() 
                        parseFloat(FormatUnits).toFixed(2)

                        var Amount = parseFloat(FormatUnits).toFixed(2) * this.NAV
                        this.Form.ExpectedAmount = Amount
                        
                }
                else{
                  parseFloat(FormatUnitsA)
                  var Amount = parseFloat(FormatUnitsA) * this.NAV
                   this.Form.ExpectedAmount = Amount
                }
            return parseFloat(Amount).toFixed(2);   
        }
    },


    methods : {
    ...mapActions(["UpdateFundList","GetListOfFund"]),
       RemoveFormat (obj){
           var vall= obj;
           vall = vall.replace(",","");
           return vall.trim()
       },
        FilterFund (val, update, abort) {
            update(() => {
                const needle = val.toLowerCase()
                this.StoreStateProduct.FundList = this.StoreStateProduct.FundOptions.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        },
        RemoveFormat (obj){
           var vall= obj;
           vall = vall.replace(",","");
           return vall.trim()
       },
        AmountUnitSelection(selItem){
            this.Form.Units = 0;
            this.Form.Amount = 0;
        },
        /* PopulateAllUnits(){
            if(this.Form.RedeemAllUnits===true){
                this.Form.Units = this.BalanceUnit
            }
            else{
                this.Form.Units = 0
            }
        }, */
        GetFund(){
            var Agree = false;
            if(this.Form.DisagreeRecommendation===false){
                Agree = true;
            }
            else
            if(this.Form.DisagreeRecommendation===true){
                Agree = false;
            }
            if(Number(this.StoreStateCD.SAT.Score) > 0 ){ 
                this.GetListOfFund({Plan:this.Form.Plan,Agree:Agree})
            }
            else{
                this.Form.Instruction = '';
                this.$q.dialog({
                    title: 'Message',
                    message: 'Kindly complete Suitability Assessment.',
                })
                .onOk(() => {
                    this.$router.push({name : 'sat'})
                })
                .onCancel(() => {
                    
                })
            }
        },
    },

    filters: {
        thousandSeparator: function(value) {
    
        if (value !== '' || value !== undefined || value !== 0  || value !== '0' || value !== '') {
            value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            var result = value;
            return result
        }else{
            var result = value.toString();
            return result
        }    
      } 
    },

    mounted(){
        if(this.StoreStateCD.BankAccount.length<0){
            // to redirect to bank account page
            this.$q.dialog({
                title: 'Message',
                message: 'Kindly setup a bank account.',
            })
            .onOk(() => {
                this.$router.push({name : 'ClientBank'})
            })
            .onCancel(() => {
            })
            .onDismiss(() => {
            })
        }
        else{
            if(this.Plan!=='EPF'){
                this.PaymentInstructionOptions = []
                for(var i=0; i<this.StoreStateCD.BankAccount.length; i++){
                    this.PaymentInstructionOptions.push({
                        label : this.StoreStateCD.BankAccount[i].label + ' - ' + this.StoreStateCD.BankAccount[i].value,
                        value : this.StoreStateCD.BankAccount[i].value
                    })
                }
            }
        }
        
    }
    
}
</script>